import { NgModule } from '@angular/core';
import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@environments/environment';

import { ConsentModule } from './consent/consent.module';
import { LibButtonModule } from './button';
import { LibChartModule } from './chart';
import { LibCheckMarkModule } from './check-mark';
import { LibConfettiModule } from './confetti';
import { LibContainerModule } from './container';
import { LibContentLoaderModule } from './content-loader';
import { LibHeaderModule } from './header';
import { LibNumberInputModule } from './number-input';
import { LibNotificationModule } from './notification';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { LibIconButtonModule } from './icon-button/icon-button.module';
import {
  CdkDrag,
  CdkDragPlaceholder,
  CdkDropList
} from '@angular/cdk/drag-drop';

const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: window.location.origin + environment.okta.callbackUri,
});
const oktaModuleConfig: OktaConfig = { oktaAuth };

@NgModule({
  imports: [
    CdkDrag,
    CdkDragPlaceholder,
    CdkDropList,
    OktaAuthModule.forRoot(oktaModuleConfig),
  ],
  exports: [
    CdkDrag,
    CdkDragPlaceholder,
    CdkDropList,
    LibButtonModule,
    LibChartModule,
    LibCheckMarkModule,
    LibConfettiModule,
    ConsentModule,
    LibContainerModule,
    LibContentLoaderModule,
    LibHeaderModule,
    LibIconButtonModule,
    LibNotificationModule,
    LibNumberInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTableModule,
  ]
})
export class LibModule {}
